import { Input } from 'app/common/components/index.js';
import { useToggle } from 'app/common/hooks/index.js';
import { useEffect } from 'react';

const FlipSwitch = ({ onCheck = () => {}, onUnCheck = () => {} }) => {
  const [checked, toggleChecked] = useToggle(false);

  useEffect(() => {
    if (checked) {
      onCheck();
    } else {
      onUnCheck();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checked]);

  return (
    <div className="flipswitch">
      <Input
        checked={checked}
        id="fs-storeLocator"
        className="flipswitch-cb"
        name="flipswitch"
        type="checkbox"
        onChange={() => {
          toggleChecked();
        }}
      />
      <label htmlFor="fs-storeLocator" className="flipswitch-label">
        <div className="flipswitch-inner"></div>
        <div className="flipswitch-switch"></div>
      </label>
    </div>
  );
};

export { FlipSwitch };
